import styled from "@emotion/styled";
import { Dropdown } from "semantic-ui-react";

const StyledDropdown = styled(Dropdown)`
  position: relative;
  width: 100%;
  min-height: 40px;
  cursor: pointer;
  border: 1px solid rgba(34, 36, 38, 0.15);
  padding: 8px;
  display: inline-block;
  outline: 0;
  text-align: left;

  input {
    position: absolute;
    background: none;
    border: none;
    cursor: text;
    top: 0;
    left: 0;
    width: 100%;
    padding: inherit;
  }
  .text {
    position: relative;
    left: 1px;
    z-index: 3;

    &.filtered {
      visibility: hidden;
    }
  }
  .menu {
    display: none;
    width: 100%;
    left: 0;
    overflow: auto;
    cursor: default;
    position: absolute;
    top: 100%;
    min-width: max-content;
    background: #fff;
    font-size: ${({ theme }) => theme.fontSizes[0]};
    text-align: left;
    outline: 1px solid;
    outline-color: ${({ theme }) => theme.effects.overlay.black_10};
    border-radius: 2px;
    z-index: 11;
    margin-top: 4px;
    max-height: 400px;
    overflow: auto;

    &.visible {
      display: block;
    }

    .item {
      position: relative;
      display: block;
      height: auto;
      text-align: left;
      cursor: pointer;
      border-bottom: 1px solid;
      border-color: ${({ theme }) => theme.effects.overlay.black_10};
      color: ${({ theme }) => theme.colors.tone.black};
      font-size: ${({ theme }) => theme.fontSizes[0]};
      font-weight: 400;
      padding: ${({ theme }) => theme.space.space16};

      &.active {
        font-weight: bold;
      }
    }

    .message {
      padding: ${({ theme }) => theme.space.space16};
    }
  }
`;

export { StyledDropdown };
